import { PricingModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class PricingService extends ApiService<PricingModel> {
	constructor() {
		super('price');
	}
}

export default new PricingService();
